import React from 'react';
import { Trophy, Crown, Wallet } from 'lucide-react';
import { truncateAddress } from '../utils/format';
import { RealtimeLeaderboard } from './leaderboard/RealtimeLeaderboard';

export function Leaderboard() {
  return <RealtimeLeaderboard />;
}